import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { GreetingItem } from '../types/greeting';

interface GreetingPreviewModalProps {
  visible: boolean;
  onClose: () => void;
  greeting: GreetingItem;
}

const GreetingPreviewModal: React.FC<GreetingPreviewModalProps> = ({
  visible,
  onClose,
  greeting,
}) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={1024}
      className="greeting-preview-modal"
      closeIcon={<CloseOutlined style={{ color: '#ffffff', fontSize: '20px' }} />}
      styles={{
        body: {
          padding: 0,
          background: '#000000',
          margin: 0,
          minHeight: '288px',
          maxHeight: '288px'
        },
        content: {
          padding: 0
        },
        mask: {
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(10px)'
        }
      }}
      centered
      destroyOnHidden={true}
      maskClosable={true}
    >
      <div
        style={{
          display: 'flex',
          width: '1024px',
          height: '288px',
          background: '#0E0E0E',
          position: 'relative',
          boxSizing: 'border-box',
          boxShadow: '0 0 0 0.2px #fff'
        }}
      >
        <img
          src="/assets/greeting_bg.png"
          alt="Greeting Preview"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
        <div style={
          {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            position: 'absolute',
            top: '44px',
            left: '44px',
            height: 'auto',
          }
        }>
          <div style={{
            fontSize: '33px',
            fontWeight: 'bold',
            color: '#ffffff',
            lineHeight: '1.25'
          }}>
            <span style={{ display: 'block' }}>{greeting.content[0]}</span>
            <span style={{ display: greeting?.content[1] ? 'block' : 'none' }}>{greeting.content[1]}</span>
          </div>
          <div style={{
            marginTop: '4px',
            fontSize: '20px',
            fontWeight: 500,
            color: '#FA853F'
          }}>
            {greeting?.visitorCompanyName} 방문을 환영합니다
          </div>
        </div>
      </div>
    </Modal >
  );
};

export default GreetingPreviewModal;
